export default __webpack_public_path__ + "static/media/11_Backyard-adventure.0b6b5731.jpg";